import React from "react";
import Hero from "@/components/sections/Hero";
import TrustStrip from "@/components/sections/TrustStrip";
import HowCanWeHelp from "@/components/sections/HowCanWeHelp";
import AllServicesGrid from "@/components/sections/AllServicesGrid";
import FamiliesAbroad from "@/components/sections/FamiliesAbroad";
import HowItWorks from "@/components/sections/HowItWorks";
import Reviews from "@/components/sections/Reviews";
import WhyChoose from "@/components/sections/WhyChoose";
import Founders from "@/components/sections/Founders";
import ServiceArea from "@/components/sections/ServiceArea";
import FAQ from "@/components/sections/FAQ";
import FromBlog from "@/components/sections/FromBlog";
import BigCTA from "@/components/sections/BigCTA";
import ContactSection from "@/components/sections/ContactSection";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <TrustStrip />
      <HowCanWeHelp />
      <AllServicesGrid />
      <FamiliesAbroad />
      <HowItWorks />
      <Reviews />
      <WhyChoose />
      <Founders />
      <ServiceArea />
      <FromBlog />
      <FAQ />
      <BigCTA />
      <ContactSection />
    </main>
  );
}
